import Factory from "@/schemas/factory";

const schema = new Factory()
    .hasId()
    .publishable()
    .hasTimestamps()
    .make();

schema.prop('name').setType(String);

export default schema;
